import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';
import { LinkedinAccount } from './linkedin-accounts.types';

interface Props {
  open: boolean;
  account: LinkedinAccount | null;
  loading: boolean;

  handleClose(): void;

  handleResetLocalStorage(): void;
}

const ResetLocalStorageDialog: React.FC<Props> = ({ open, account, loading, handleClose, handleResetLocalStorage }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'} transitionDuration={0}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('resetLocalStorage')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>
            <Trans i18nKey={'resetLocalStorageContent1'} values={{ userName: account?.userEmail }}>
              Should the local storage for account <strong>{account?.userEmail}</strong> really be reset?
            </Trans>
          </Typography>
          <Typography className={classes.text}>{t('resetLocalStorageContent2')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} action={handleResetLocalStorage} disabled={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.info.main}, ${theme.palette.info.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default ResetLocalStorageDialog;

